/* eslint-disable */
import ReactDOM from "react-dom";
import { get } from 'lodash';
import buildResponses from '@unite-us/surveyjs/dist/components/Renderer/buildResponses';
import { ELEMENT_DICTIONARY, OPTION_DICTIONARY } from "src/pages/facesheet/_id/eligibility/surveyjsTemplates/createElAssessTemplate"

export const ELIGIBLE_SERVICES_LIST = [
  {
    name: 'Clinically Appropriate Meals',
    need: 'Food',
  },
  {
    name: 'Cooking Supplies',
    need: 'Food',
  },
  {
    name: 'Fresh Produce and Nonperishable Groceries - Pantry Stocking',
    need: 'Food',
  },
  {
    name: 'Medically Tailored Meals (MTM)',
    need: 'Food',
  },
  {
    name: 'Nutritional Counseling and Education',
    need: 'Food',
  },
  {
    name: 'Asthma Remediation',
    need: 'Housing/Utilities',
  },
  {
    name: 'Community Transitional Supports',
    need: 'Housing/Utilities',
  },
  {
    name: 'Home Accessibility / Safety Modification',
    need: 'Housing/Utilities',
  },
  {
    name: 'Home Remediation Assistance',
    need: 'Housing/Utilities',
  },
  {
    name: 'Home Remediation Assistance: Refrigerator',
    need: 'Housing/Utilities',
  },
  {
    name: 'Home Remediation Assistance: Space Heater',
    need: 'Housing/Utilities',
  },
  {
    name: 'Housing Transition and Navigation Services',
    need: 'Housing/Utilities',
  },
  {
    name: 'Pre-tenancy Services',
    need: 'Housing/Utilities',
  },
  {
    name: 'Utility Payment Assistance',
    need: 'Housing/Utilities',
  },
  {
    name: 'Rent/Temporary Housing Rent Payment Assistance',
    need: 'Housing/Utilities',
  },
  {
    name: 'Rent/Temporary Housing Rent Payment Assistance - Four Bedroom Unit (per month)',
    need: 'Housing/Utilities',
  },
  {
    name: 'Tenancy Sustaining services',
    need: 'Housing/Utilities',
  },
  {
    name: 'Utility Activation Payment',
    need: 'Housing/Utilities',
  },
  {
    name: 'Utility Arrears Payment',
    need: 'Housing/Utilities',
  },
  {
    name: 'Medical Respite - Preprocedural Care',
    need: 'Housing/Utilities',
  },
  {
    name: 'Medical Respite - Post Hospitalization Care',
    need: 'Housing/Utilities',
  },
  {
    name: 'Private Transportation',
    need: 'Transportation',
  },
  {
    name: 'Public Transportation',
    need: 'Transportation',
  }
];

export const getServiceNeed = (service) => {
  const serviceObj = ELIGIBLE_SERVICES_LIST.find((s) => s.name === service);
  return serviceObj?.need;
};

export const getEligibilityAssessmentStatusLabel = (status, outreach_status) => {
  if (outreach_status?.toLowerCase() === 'declined') {
    return 'Outreach Failed';
  }
  return status;
};

export const buildAnswersPayload = (surveyRef, surveyJSON) => {
  const survey = surveyRef.current;

  const responses = buildResponses(surveyRef.current);
  const answers = responses
    .filter((response) => {
      if (['qSelectScreening'].includes(response.name)) {
        return false;
      }
      return true;
    })
    .map((response) => {
      let option_id = null;
      const optionsSelected = response.custom.map((c) => c.option.uuid || c.option.id);
      const questionType = get(response, 'custom[0].question.type', '');
      option_id = optionsSelected;
      
      if (response.value) {
        option_id = response.value;
      } else if (questionType === 'select_multiple') {
        option_id = Array.isArray(optionsSelected) ? optionsSelected : [optionsSelected];
      } else if (optionsSelected.length > 1) {
        option_id = optionsSelected;
      } else {
        option_id = optionsSelected[0];
      }
      return {
        question_id: response.custom[0].questionId,
        option_id,
      }
    });

  return answers;
};

export const SELECT_SCREENING_QUESTION = 'Select screening to validate HRSN social needs';

export const ELIGIBILITY_ASSESSMENT_STATUS = {
  DRAFT: 'draft',
  COMPLETE: 'complete',
  DECLINED: 'declined',
};

export const DECLINED_REASON = "Client declined consent to participate in the Eligibility Assessment";

export const FoodSVG = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5714 0.857143V9.42857C11.5714 9.97321 11.4129 10.4688 11.096 10.9152C10.779 11.3616 10.3661 11.6741 9.85714 11.8527V22.2857C9.85714 22.75 9.6875 23.1518 9.34822 23.4911C9.00893 23.8304 8.60714 24 8.14286 24H6.42857C5.96429 24 5.5625 23.8304 5.22321 23.4911C4.88393 23.1518 4.71429 22.75 4.71429 22.2857V11.8527C4.20536 11.6741 3.79241 11.3616 3.47545 10.9152C3.15848 10.4688 3 9.97321 3 9.42857V0.857143C3 0.625 3.08482 0.424107 3.25446 0.254464C3.42411 0.0848214 3.625 0 3.85714 0C4.08929 0 4.29018 0.0848214 4.45982 0.254464C4.62946 0.424107 4.71429 0.625 4.71429 0.857143V6.42857C4.71429 6.66071 4.79911 6.86161 4.96875 7.03125C5.13839 7.20089 5.33929 7.28571 5.57143 7.28571C5.80357 7.28571 6.00446 7.20089 6.17411 7.03125C6.34375 6.86161 6.42857 6.66071 6.42857 6.42857V0.857143C6.42857 0.625 6.51339 0.424107 6.68304 0.254464C6.85268 0.0848214 7.05357 0 7.28571 0C7.51786 0 7.71875 0.0848214 7.88839 0.254464C8.05804 0.424107 8.14286 0.625 8.14286 0.857143V6.42857C8.14286 6.66071 8.22768 6.86161 8.39732 7.03125C8.56697 7.20089 8.76786 7.28571 9 7.28571C9.23214 7.28571 9.43304 7.20089 9.60268 7.03125C9.77232 6.86161 9.85714 6.66071 9.85714 6.42857V0.857143C9.85714 0.625 9.94196 0.424107 10.1116 0.254464C10.2813 0.0848214 10.4821 0 10.7143 0C10.9464 0 11.1473 0.0848214 11.317 0.254464C11.4866 0.424107 11.5714 0.625 11.5714 0.857143ZM21.8571 0.857143V22.2857C21.8571 22.75 21.6875 23.1518 21.3482 23.4911C21.0089 23.8304 20.6071 24 20.1429 24H18.4286C17.9643 24 17.5625 23.8304 17.2232 23.4911C16.8839 23.1518 16.7143 22.75 16.7143 22.2857V15.4286H13.7143C13.5982 15.4286 13.4978 15.3862 13.4129 15.3013C13.3281 15.2165 13.2857 15.1161 13.2857 15V4.28571C13.2857 3.10714 13.7054 2.09821 14.5446 1.25893C15.3839 0.419643 16.3929 0 17.5714 0H21C21.2321 0 21.433 0.0848214 21.6027 0.254464C21.7723 0.424107 21.8571 0.625 21.8571 0.857143Z" fill="#2C405A"/>
  </svg>
);

export const HousingSVG = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5745 13.001V20.1464C20.5745 20.4044 20.4802 20.6277 20.2917 20.8163C20.1031 21.0048 19.8798 21.0991 19.6218 21.0991H13.9054V15.3828H10.0946V21.0991H4.37822C4.12019 21.0991 3.8969 21.0048 3.70834 20.8163C3.51978 20.6277 3.4255 20.4044 3.4255 20.1464V13.001C3.4255 12.991 3.42798 12.9762 3.43294 12.9563C3.43791 12.9365 3.44039 12.9216 3.44039 12.9116L12 5.85555L20.5596 12.9116C20.5695 12.9315 20.5745 12.9613 20.5745 13.001ZM23.8941 11.9738L22.9712 13.0754C22.8918 13.1647 22.7876 13.2193 22.6586 13.2391H22.6139C22.4849 13.2391 22.3807 13.2044 22.3013 13.1349L12 4.54555L1.69869 13.1349C1.5796 13.2143 1.46051 13.2491 1.34142 13.2391C1.21241 13.2193 1.1082 13.1647 1.02881 13.0754L0.105858 11.9738C0.0264645 11.8746 -0.00827016 11.758 0.00165403 11.624C0.0115782 11.49 0.0661613 11.3833 0.165403 11.3039L10.8686 2.38704C11.1862 2.12901 11.5633 2 12 2C12.4367 2 12.8138 2.12901 13.1314 2.38704L16.7636 5.42385V2.52102C16.7636 2.38208 16.8083 2.26795 16.8976 2.17864C16.9869 2.08932 17.101 2.04466 17.24 2.04466H20.0981C20.2371 2.04466 20.3512 2.08932 20.4405 2.17864C20.5298 2.26795 20.5745 2.38208 20.5745 2.52102V8.59462L23.8346 11.3039C23.9338 11.3833 23.9884 11.49 23.9983 11.624C24.0083 11.758 23.9735 11.8746 23.8941 11.9738Z" fill="#2C405A"/>
  </svg>
);

export const NEEDS_ICONS = {
  'food': FoodSVG,
  'housing': HousingSVG
};

export const OTHER_NEEDS = [
  'Transportation',
];

export const NEEDS_KEYS = {
  'Transportation': {
    headerName: 'transportation_need_header',
    needName: 'transportation_need',
  },
};

export const NotEligibleHtml = `
<div>
  <button style="background-color: rgba(68, 103, 171, var(--bg-opacity)); color: white; border-radius: 2px; padding-left: 5px; padding-right: 5px; padding-top: 2px; padding-bottom: 2px; font-weight: bold; font-size: 20px;" className="font-bold bg-white text-lg">You are not eligible. Back!</button>
</div>
`;

// identifiedNeeds is an array of strings (e.g. ['food', 'housing'])
// screening is the eligibility assessment screening object
export const getEligibleServicesUtil = (screening, identifiedNeeds) => {
  try {
    if (!screening) { return null; }

    const { template_version } = screening.data.screen;

    const isV2 = template_version === '2';
    const isV3 = template_version === '3';

    const eligibleServices = [];

    const screen = screening.data.screen;
    const qVerifyMedicaidEnrollment = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qVerifyMedicaidEnrollment
    );
    const qVerifyIdentity = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qVerifyIdentity
    );
    const qConfirmAccurateInfo = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qConfirmAccurateInfo
    );
    // const qConnectToServices = screen.questions.find(
    //   (q) => q.primary_text === ELEMENT_DICTIONARY.qConnectToServices
    // );

    const qFoodAssistance = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qFoodAssistance
    );
    const qHousingUtilitiesAssistance = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qHousingUtilitiesAssistance
    );
    const qTransportationAssistance = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qTransportationAssistance
    );
    const qFoodServiceDuplicationCheck = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qFoodServiceDuplicationCheck
    );
    const qEnhancedPopulations = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qEnhancedPopulations
    );
    const qClinicalCriteria = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qClinicalCriteria
    );
    const qDifficultyWalking = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qDifficultyWalking
    );
    const qDifficultyDressing = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qDifficultyDressing
    );

    // V2 only
    const qIDDVerification = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qIDDVerification
    );
    const qRefrigerationBreastMilk = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qRefrigerationBreastMilk
    );
    const qRefrigerationMedication = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qRefrigerationMedication
    );
    const qTransportationTroubleReasons = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qTransportationTroubleReasons
    );
    const qSelectScreening = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qSelectScreening
    );

    let hasOutreachSuccess = get(screen, 'outreach_status') === 'success';

    let hasAccurateInfo = get(qConfirmAccurateInfo, 'answer.value') === "Member attests to provide accurate and complete information.";
    let hasVerifiedIdentity = get(qVerifyIdentity, 'answer.value') === "I was able to verify member's identity.";
    let hasVerifiedMedicaid = get(qVerifyMedicaidEnrollment, 'answer.value') === 'I was able to verify the member is currently enrolled in Medicaid.';
    // let wantsToBeConnectedToServices = get(qConnectToServices, 'answer.value') === OPTION_DICTIONARY.memberConsentsToConnect;

    let hasValidScreening = Boolean(get(qSelectScreening, 'answer.value'));

    const wantsFoodAssistance = get(qFoodAssistance, 'answer.value') === 'Yes';
    const wantsHousingOrUtilitiesAssistance = get(qHousingUtilitiesAssistance, 'answer.value') === 'Yes';
    const wantsTransportationAssistance = get(qTransportationAssistance, 'answer.value') === 'Yes';

    const hasFoodNeed = Boolean(
      identifiedNeeds.includes('food') && wantsFoodAssistance
    );
    const hasHousingOrUtilitiesNeed = Boolean(
      (identifiedNeeds.includes('housing') || identifiedNeeds.includes('utilities')) &&
      wantsHousingOrUtilitiesAssistance
    );
    const hasTransportationNeed = Boolean(
      identifiedNeeds.includes('transportation') && wantsTransportationAssistance
    );

    const enhancedPopulations = get(qEnhancedPopulations, 'answers', []).map((a) => a.value);
    const clinicalCriteria = get(qClinicalCriteria, 'answers', []).map((a) => a.value);
    
    const hasDifficultyWalking = get(qDifficultyWalking, 'answer.value') === 'Yes';
    const hasDifficultyDressing = get(qDifficultyDressing, 'answer.value') === 'Yes';
    // V2 only
    const hasIDDVerificationProviderAttestation = get(qIDDVerification, 'answer.value') === 'Provider Attestation';
    
    const requireRefrigerationBreastMilk = get(qRefrigerationBreastMilk, 'answer.value') === 'Yes';
    const requireRefrigerationMedication = get(qRefrigerationMedication, 'answer.value') === 'Yes';
    
    const transportationTroubleReasons = get(qTransportationTroubleReasons, 'answers', []).map((a) => a.value);

    // Get all snomed codes selected 
    const snomedCodesSelected = [];

    const optionIdToSnomedCodeMap = {};
    // const snomedCodesAvailable = [];  // for debugging purposes
    screen.questions.forEach((q) => {
      if (!q.options) { return; }
      q.options.forEach((o) => {
        if (o.snomed) {
          optionIdToSnomedCodeMap[o.id] = o.snomed;
          // snomedCodesAvailable.push({ // for debugging purposes
          //   question: q.primary_text,
          //   option_value: o.value,
          //   snomed: o.snomed,
          // });
        }
      });
    })

    screen.questions.forEach((q) => {
      if (!q.answer && !q.answers) { return; }
      if (q.answer) {
        const snomedCode = optionIdToSnomedCodeMap[q.answer.option_id];
        if (snomedCode) {
          snomedCodesSelected.push(snomedCode);
        }
      }
      if (q.answers) {
        q.answers.forEach((a) => {
          const snomedCode = optionIdToSnomedCodeMap[a.option_id];
          if (snomedCode) {
            snomedCodesSelected.push(snomedCode);
          }
        });
      }
    });

    // Check if the client is eligible for services
    if (
      !hasAccurateInfo ||
      !hasVerifiedIdentity ||
      !hasVerifiedMedicaid ||
      // !wantsToBeConnectedToServices ||
      !hasValidScreening
    ) {
      return [];
    }

    // Clinically Appropriate Meals
    if (
      hasFoodNeed &&
      get(qFoodServiceDuplicationCheck, 'answer.value') === 'No' &&
      enhancedPopulations.length > 0
    ) {
      eligibleServices.push('Clinically Appropriate Meals');
      eligibleServices.push('Medically Tailored Meals (MTM)');
    }

    // Cooking Supplies
    if (
      hasFoodNeed &&
      enhancedPopulations.length > 0
    ) {
      eligibleServices.push('Cooking Supplies');
      eligibleServices.push('Nutritional Counseling and Education');
    }

    // Fresh Produce
    if (
      hasFoodNeed &&
      (
        enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
        enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen) ||
        enhancedPopulations.includes(OPTION_DICTIONARY.childNutrition)
      )
    ) {
      eligibleServices.push('Fresh Produce and Nonperishable Groceries - Pantry Stocking');
    }

    // Asthma Remediation
    if (
      hasHousingOrUtilitiesNeed &&
      clinicalCriteria.includes(OPTION_DICTIONARY.asthma) &&
      enhancedPopulations.length
    ) {
      eligibleServices.push('Asthma Remediation');
    }

    // Community Transitional Support
    if (
      hasHousingOrUtilitiesNeed &&
      enhancedPopulations.length &&
      (
        snomedCodesSelected.includes('611551000124102') ||
        snomedCodesSelected.includes('611131000124100') ||
        snomedCodesSelected.includes('611141000124105') ||
        snomedCodesSelected.includes('611181000124104') ||
        snomedCodesSelected.includes('32911000')
      )
    ) {
      eligibleServices.push('Community Transitional Supports');
    }

    // Home Accessibility
    if (
      hasHousingOrUtilitiesNeed &&
      (
        hasDifficultyWalking ||
        hasDifficultyDressing
      ) &&
      hasIDDVerificationProviderAttestation
    ) {
      eligibleServices.push('Home Accessibility / Safety Modification');
    }

    // Home Remediation
    if (
      (
        isV2 && hasHousingOrUtilitiesNeed &&
        (
          clinicalCriteria.includes(OPTION_DICTIONARY.chronicCondition) ||
          clinicalCriteria.includes(OPTION_DICTIONARY.heatRelatedIllness) ||
          clinicalCriteria.includes(OPTION_DICTIONARY.coldRelatedIllness) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.idd) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.sud) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.mentalHealth)
        )
      ) ||
      (
        isV3 && hasHousingOrUtilitiesNeed &&
        (
          clinicalCriteria.includes(OPTION_DICTIONARY.chronicCondition) ||
          clinicalCriteria.includes(OPTION_DICTIONARY.heatRelatedIllness) ||
          clinicalCriteria.includes(OPTION_DICTIONARY.coldRelatedIllness) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.otherPopulations) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.childNutrition)
        )
      )
    ) {
      eligibleServices.push('Home Remediation Assistance');
      eligibleServices.push('Home Remediation Assistance: Space Heater')
    }

    // Refrigeration
    if (
      hasHousingOrUtilitiesNeed &&
      enhancedPopulations.length &&
      (
        requireRefrigerationBreastMilk ||
        requireRefrigerationMedication ||
        clinicalCriteria.includes(OPTION_DICTIONARY.enternalOrParenteral)
      )
    ) {
      eligibleServices.push('Home Remediation Assistance: Refrigerator');
    }

    // Housing Transition
    if (
      (
        isV2 && hasHousingOrUtilitiesNeed &&
        (
          enhancedPopulations.includes(OPTION_DICTIONARY.medicaidHighUtilizer) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.enrolledNYS) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.sud) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.mentalHealth) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.idd) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.juvenileJustice) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen)
        ) &&
        (
          snomedCodesSelected.includes('611551000124102') ||
          snomedCodesSelected.includes('611131000124100') ||
          snomedCodesSelected.includes('611141000124105') ||
          snomedCodesSelected.includes('611181000124104') ||
          snomedCodesSelected.includes('32911000')
        )
      ) ||
      (
        isV3 && hasHousingOrUtilitiesNeed &&
        (
          enhancedPopulations.includes(OPTION_DICTIONARY.medicaidHighUtilizer) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.enrolledNYS) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.otherPopulations) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.childNutrition)
        ) &&
        (
          snomedCodesSelected.includes('611551000124102') ||
          snomedCodesSelected.includes('611131000124100') ||
          snomedCodesSelected.includes('611141000124105') ||
          snomedCodesSelected.includes('611181000124104') ||
          snomedCodesSelected.includes('32911000')
        )
      )
    ) {
      eligibleServices.push('Housing Transition and Navigation Services');
      eligibleServices.push('Pre-tenancy Services');
      eligibleServices.push('Tenancy Sustaining services')
    }

    // Utility Payment
    if (
      (
        isV2 && hasHousingOrUtilitiesNeed &&
        (
          (
            enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
            enhancedPopulations.includes(OPTION_DICTIONARY.mentalHealth) ||
            enhancedPopulations.includes(OPTION_DICTIONARY.idd) ||
            enhancedPopulations.includes(OPTION_DICTIONARY.juvenileJustice)
          ) ||
          (
            snomedCodesSelected.includes('611551000124102') ||
            snomedCodesSelected.includes('611131000124100') ||
            snomedCodesSelected.includes('611141000124105') ||
            snomedCodesSelected.includes('611181000124104') ||
            snomedCodesSelected.includes('32911000')
          )
        )
      ) ||
      (
        isV3 && hasHousingOrUtilitiesNeed &&
        (
          (
            enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
            enhancedPopulations.includes(OPTION_DICTIONARY.otherPopulations)
          ) ||
          (
            snomedCodesSelected.includes('611551000124102') ||
            snomedCodesSelected.includes('611131000124100') ||
            snomedCodesSelected.includes('611141000124105') ||
            snomedCodesSelected.includes('611181000124104') ||
            snomedCodesSelected.includes('32911000')
          )
        )
      )
    ) {
      eligibleServices.push('Utility Payment Assistance');
      eligibleServices.push('Rent/Temporary Housing Rent Payment Assistance');
      eligibleServices.push('Rent/Temporary Housing Rent Payment Assistance - Four Bedroom Unit (per month)');
      eligibleServices.push('Utility Activation Payment');
      eligibleServices.push('Utility Arrears Payment');
    }

    // Transportation
    if (
      (
        isV2 && hasTransportationNeed &&
        (
          enhancedPopulations.includes(OPTION_DICTIONARY.medicaidHighUtilizer) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.enrolledNYS) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.sud) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.mentalHealth) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.idd) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.juvenileJustice) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen)
        ) &&
        (
          (
            snomedCodesSelected.includes('551761000124107') ||
            snomedCodesSelected.includes('551741000124108') ||
            snomedCodesSelected.includes('551721000124101') ||
            snomedCodesSelected.includes('611151000124107') ||
            snomedCodesSelected.includes('551701000124106') ||
            snomedCodesSelected.includes('551711000124109') ||
            snomedCodesSelected.includes('160696009')
          ) ||
          (
            transportationTroubleReasons.includes("I don't have a valid driver's license") ||
            transportationTroubleReasons.includes("I don't have access to a vehicle")
          )
        )
      ) ||
      (
        isV3 && hasTransportationNeed &&
        (
          enhancedPopulations.includes(OPTION_DICTIONARY.medicaidHighUtilizer) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.enrolledNYS) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.otherPopulations) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.pregnantAndPostpartum) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.individualsChronicReleased) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.highRiskChildUnderEighteen) ||
          enhancedPopulations.includes(OPTION_DICTIONARY.childNutrition)
        ) &&
        (
          (
            snomedCodesSelected.includes('551761000124107') ||
            snomedCodesSelected.includes('551741000124108') ||
            snomedCodesSelected.includes('551721000124101') ||
            snomedCodesSelected.includes('611151000124107') ||
            snomedCodesSelected.includes('551701000124106') ||
            snomedCodesSelected.includes('551711000124109') ||
            snomedCodesSelected.includes('160696009')
          ) ||
          (
            transportationTroubleReasons.includes("I don't have a valid driver's license") ||
            transportationTroubleReasons.includes("I don't have access to a vehicle")
          )
        )
      )
    ) {
      eligibleServices.push('Private Transportation');
      eligibleServices.push('Public Transportation');
    }

    return eligibleServices;
  } catch (error) {
    console.error('Error getting eligible services', error);
    return [];
  }
};

export const formatDateToScreeningFormat = (dateString) => {
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  const dateObj = new Date(dateString);
  const formattedDate = dateObj.toLocaleDateString('en-US', options);
  return formattedDate;
};

export const getIdentifiedNeedsHTML = (needs) => {
  const containerClass = "border-solid border border-dark-pale-blue bg-lighter-grey px-6 py-6 mb-5";
  if (!needs || !needs.length) {
    return `
      <div class="${containerClass}">
        <p class="text-lg font-bold">
          No needs identified from the selected screening.
        </p>
      </div>
    `;
  }
  let html = `
    <div class="${containerClass}">
      <p class="text-lg font-bold mb-5">
        Last Screening identified these Health Related Social Needs:
      </p>
  `;

  if (needs.includes('transportation')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4129_5764)">
              <path d="M5.62512 14.2498C5.62512 13.7349 5.44195 13.2921 5.07417 12.9258C4.90281 12.7484 4.69692 12.608 4.46921 12.5132C4.24149 12.4185 3.99678 12.3714 3.75016 12.3748C3.23527 12.3748 2.79249 12.558 2.42615 12.9258C2.05837 13.2921 1.8752 13.7334 1.8752 14.2498C1.8752 14.7661 2.05837 15.2075 2.42615 15.5738C2.79249 15.9416 3.23382 16.1247 3.75016 16.1247C4.26505 16.1247 4.70783 15.9416 5.07417 15.5738C5.44195 15.2075 5.62512 14.7661 5.62512 14.2498ZM6.04627 10.4999H17.9523L16.9095 6.31724C16.8951 6.25378 16.8403 6.186 16.7465 6.111C16.6528 6.03744 16.5706 5.99994 16.4999 5.99994H7.50009C7.42942 5.99994 7.34721 6.03744 7.2549 6.111C7.15971 6.186 7.1049 6.25378 7.09048 6.3158L6.04627 10.4999ZM22.1248 14.2498C22.1248 13.7349 21.9416 13.2921 21.5739 12.9258C21.4025 12.7484 21.1966 12.608 20.9689 12.5132C20.7412 12.4185 20.4965 12.3714 20.2498 12.3748C19.7349 12.3748 19.2922 12.558 18.9258 12.9258C18.558 13.2921 18.3749 13.7334 18.3749 14.2498C18.3749 14.7661 18.558 15.2075 18.9258 15.5738C19.2922 15.9416 19.7335 16.1247 20.2498 16.1247C20.7662 16.1247 21.2075 15.9416 21.5739 15.5738C21.9416 15.2075 22.1248 14.7661 22.1248 14.2498ZM23.9998 13.1248V17.6247C24.0015 17.6745 23.9931 17.7241 23.975 17.7705C23.9569 17.8168 23.9295 17.859 23.8945 17.8944C23.8591 17.9294 23.8169 17.9569 23.7705 17.975C23.7241 17.9931 23.6745 18.0015 23.6248 17.9997H22.4998V19.4997C22.4998 20.1242 22.2806 20.6564 21.8436 21.0934C21.6369 21.3059 21.3888 21.4737 21.1147 21.5866C20.8406 21.6995 20.5462 21.755 20.2498 21.7496C19.6253 21.7496 19.0931 21.5304 18.6561 21.0934C18.4436 20.8867 18.2758 20.6386 18.1629 20.3645C18.0501 20.0904 17.9946 19.7961 17.9999 19.4997V17.9997H6.00012V19.4997C6.00012 20.1242 5.78089 20.6564 5.34388 21.0934C5.13717 21.3059 4.8891 21.4737 4.61499 21.5866C4.34089 21.6995 4.04655 21.755 3.75016 21.7496C3.12565 21.7496 2.59345 21.5304 2.15644 21.0934C1.94396 20.8867 1.77611 20.6386 1.66324 20.3645C1.55037 20.0904 1.49489 19.7961 1.5002 19.4997V17.9997H0.375226C0.325466 18.0015 0.275867 17.9931 0.229484 17.975C0.1831 17.9569 0.140913 17.9294 0.10552 17.8944C0.0704973 17.859 0.043089 17.8168 0.0249821 17.7705C0.00687524 17.7241 -0.00154715 17.6745 0.000233392 17.6247V13.1248C0.000233392 12.3979 0.255517 11.7792 0.767526 11.2671C1.00831 11.0191 1.29738 10.8231 1.61688 10.6911C1.93639 10.5591 2.27955 10.494 2.62518 10.4999H2.95258L4.18429 5.59033C4.36313 4.85477 4.76985 4.24036 5.40301 3.74422C5.99568 3.26241 6.73629 2.99958 7.50009 3H16.4999C17.2643 3 17.9653 3.24807 18.597 3.74422C19.2316 4.24036 19.6354 4.85477 19.8157 5.59033L21.046 10.4999H21.3748C22.1017 10.4999 22.7205 10.7551 23.2325 11.2671C23.7445 11.7792 23.9998 12.3979 23.9998 13.1248Z" fill="#182A44"/>
            </g>
            <defs>
              <clipPath id="clip0_4129_5764">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Transportation
        </span>
      </div>
    `;
  }

  if (needs.includes('food')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5714 0.857143V9.42857C11.5714 9.97321 11.4129 10.4688 11.096 10.9152C10.779 11.3616 10.3661 11.6741 9.85714 11.8527V22.2857C9.85714 22.75 9.6875 23.1518 9.34822 23.4911C9.00893 23.8304 8.60714 24 8.14286 24H6.42857C5.96429 24 5.5625 23.8304 5.22321 23.4911C4.88393 23.1518 4.71429 22.75 4.71429 22.2857V11.8527C4.20536 11.6741 3.79241 11.3616 3.47545 10.9152C3.15848 10.4688 3 9.97321 3 9.42857V0.857143C3 0.625 3.08482 0.424107 3.25446 0.254464C3.42411 0.0848214 3.625 0 3.85714 0C4.08929 0 4.29018 0.0848214 4.45982 0.254464C4.62946 0.424107 4.71429 0.625 4.71429 0.857143V6.42857C4.71429 6.66071 4.79911 6.86161 4.96875 7.03125C5.13839 7.20089 5.33929 7.28571 5.57143 7.28571C5.80357 7.28571 6.00446 7.20089 6.17411 7.03125C6.34375 6.86161 6.42857 6.66071 6.42857 6.42857V0.857143C6.42857 0.625 6.51339 0.424107 6.68304 0.254464C6.85268 0.0848214 7.05357 0 7.28571 0C7.51786 0 7.71875 0.0848214 7.88839 0.254464C8.05804 0.424107 8.14286 0.625 8.14286 0.857143V6.42857C8.14286 6.66071 8.22768 6.86161 8.39732 7.03125C8.56697 7.20089 8.76786 7.28571 9 7.28571C9.23214 7.28571 9.43304 7.20089 9.60268 7.03125C9.77232 6.86161 9.85714 6.66071 9.85714 6.42857V0.857143C9.85714 0.625 9.94196 0.424107 10.1116 0.254464C10.2813 0.0848214 10.4821 0 10.7143 0C10.9464 0 11.1473 0.0848214 11.317 0.254464C11.4866 0.424107 11.5714 0.625 11.5714 0.857143ZM21.8571 0.857143V22.2857C21.8571 22.75 21.6875 23.1518 21.3482 23.4911C21.0089 23.8304 20.6071 24 20.1429 24H18.4286C17.9643 24 17.5625 23.8304 17.2232 23.4911C16.8839 23.1518 16.7143 22.75 16.7143 22.2857V15.4286H13.7143C13.5982 15.4286 13.4978 15.3862 13.4129 15.3013C13.3281 15.2165 13.2857 15.1161 13.2857 15V4.28571C13.2857 3.10714 13.7054 2.09821 14.5446 1.25893C15.3839 0.419643 16.3929 0 17.5714 0H21C21.2321 0 21.433 0.0848214 21.6027 0.254464C21.7723 0.424107 21.8571 0.625 21.8571 0.857143Z" fill="#2C405A"/>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Food
        </span>
      </div>
    `;
  }

  if (needs.includes('housing')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5745 13.001V20.1464C20.5745 20.4044 20.4802 20.6277 20.2917 20.8163C20.1031 21.0048 19.8798 21.0991 19.6218 21.0991H13.9054V15.3828H10.0946V21.0991H4.37822C4.12019 21.0991 3.8969 21.0048 3.70834 20.8163C3.51978 20.6277 3.4255 20.4044 3.4255 20.1464V13.001C3.4255 12.991 3.42798 12.9762 3.43294 12.9563C3.43791 12.9365 3.44039 12.9216 3.44039 12.9116L12 5.85555L20.5596 12.9116C20.5695 12.9315 20.5745 12.9613 20.5745 13.001ZM23.8941 11.9738L22.9712 13.0754C22.8918 13.1647 22.7876 13.2193 22.6586 13.2391H22.6139C22.4849 13.2391 22.3807 13.2044 22.3013 13.1349L12 4.54555L1.69869 13.1349C1.5796 13.2143 1.46051 13.2491 1.34142 13.2391C1.21241 13.2193 1.1082 13.1647 1.02881 13.0754L0.105858 11.9738C0.0264645 11.8746 -0.00827016 11.758 0.00165403 11.624C0.0115782 11.49 0.0661613 11.3833 0.165403 11.3039L10.8686 2.38704C11.1862 2.12901 11.5633 2 12 2C12.4367 2 12.8138 2.12901 13.1314 2.38704L16.7636 5.42385V2.52102C16.7636 2.38208 16.8083 2.26795 16.8976 2.17864C16.9869 2.08932 17.101 2.04466 17.24 2.04466H20.0981C20.2371 2.04466 20.3512 2.08932 20.4405 2.17864C20.5298 2.26795 20.5745 2.38208 20.5745 2.52102V8.59462L23.8346 11.3039C23.9338 11.3833 23.9884 11.49 23.9983 11.624C24.0083 11.758 23.9735 11.8746 23.8941 11.9738Z" fill="#2C405A"/>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Housing
        </span>
      </div>
    `;
  }

  if (needs.includes('interpersonal_safety')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5745 13.001V20.1464C20.5745 20.4044 20.4802 20.6277 20.2917 20.8163C20.1031 21.0048 19.8798 21.0991 19.6218 21.0991H13.9054V15.3828H10.0946V21.0991H4.37822C4.12019 21.0991 3.8969 21.0048 3.70834 20.8163C3.51978 20.6277 3.4255 20.4044 3.4255 20.1464V13.001C3.4255 12.991 3.42798 12.9762 3.43294 12.9563C3.43791 12.9365 3.44039 12.9216 3.44039 12.9116L12 5.85555L20.5596 12.9116C20.5695 12.9315 20.5745 12.9613 20.5745 13.001ZM23.8941 11.9738L22.9712 13.0754C22.8918 13.1647 22.7876 13.2193 22.6586 13.2391H22.6139C22.4849 13.2391 22.3807 13.2044 22.3013 13.1349L12 4.54555L1.69869 13.1349C1.5796 13.2143 1.46051 13.2491 1.34142 13.2391C1.21241 13.2193 1.1082 13.1647 1.02881 13.0754L0.105858 11.9738C0.0264645 11.8746 -0.00827016 11.758 0.00165403 11.624C0.0115782 11.49 0.0661613 11.3833 0.165403 11.3039L10.8686 2.38704C11.1862 2.12901 11.5633 2 12 2C12.4367 2 12.8138 2.12901 13.1314 2.38704L16.7636 5.42385V2.52102C16.7636 2.38208 16.8083 2.26795 16.8976 2.17864C16.9869 2.08932 17.101 2.04466 17.24 2.04466H20.0981C20.2371 2.04466 20.3512 2.08932 20.4405 2.17864C20.5298 2.26795 20.5745 2.38208 20.5745 2.52102V8.59462L23.8346 11.3039C23.9338 11.3833 23.9884 11.49 23.9983 11.624C24.0083 11.758 23.9735 11.8746 23.8941 11.9738Z" fill="#2C405A"/>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Interpersonal Safety
        </span>
      </div>
    `;
  }

  if (needs.includes('utilities')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4129_5768)">
              <path d="M18.9402 5.45774H21.2308V13.4453H18.9402V5.45774ZM3 15.1394H10.989V17.4299H3V15.1394ZM14.5862 5.26093H13.316V3.77424C13.6914 3.60317 13.9987 3.31703 14.2046 2.96126H17.2567C17.5171 2.96126 17.7668 2.85782 17.951 2.6737C18.1351 2.48958 18.2385 2.23986 18.2385 1.97947C18.2385 1.71909 18.1351 1.46936 17.951 1.28524C17.7668 1.10112 17.5171 0.997684 17.2567 0.997684H14.2062C14.0349 0.695473 13.7867 0.44398 13.4867 0.26875C13.1868 0.0935201 12.8458 0.000797188 12.4984 0C12.1515 0.000911893 11.8109 0.0935327 11.5113 0.268475C11.2116 0.443418 10.9636 0.694464 10.7922 0.99617H7.73862C7.47823 0.99617 7.22851 1.09961 7.04439 1.28373C6.86027 1.46785 6.75683 1.71757 6.75683 1.97796C6.75683 2.23834 6.86027 2.48807 7.04439 2.67219C7.22851 2.85631 7.47823 2.95974 7.73862 2.95974H10.7922C10.9966 3.31552 11.3039 3.60165 11.6809 3.77273V5.26093H10.4092V6.47965H9.80363C8.27071 6.48085 6.80088 7.09012 5.71666 8.17377C4.63244 9.25743 4.0224 10.7269 4.02039 12.2599V14.2416H9.96713V14.0221C9.98962 13.5923 10.1761 13.1875 10.4882 12.8912C10.8003 12.5949 11.2142 12.4296 11.6446 12.4294V12.4234H18.0425V6.47965H14.5862V5.26093ZM8.63033 22.3729C8.61723 22.8089 8.43483 23.2226 8.12182 23.5264C7.80881 23.8301 7.3898 24 6.95364 24C6.51748 24 6.09847 23.8301 5.78546 23.5264C5.47246 23.2226 5.29006 22.8089 5.27696 22.3729C5.27696 21.4464 6.95289 18.8455 6.95289 18.8455C6.95289 18.8455 8.63033 21.4464 8.63033 22.3729Z" fill="#182A44"/>
            </g>
            <defs>
              <clipPath id="clip0_4129_5768">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Utilities
        </span>
      </div>
    `;
  }

  if (needs.includes('unemployment')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 19 17" fill="black" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66666667,2.66666667 L12,2.66666667 L12,1.33333333 L6.66666667,1.33333333 L6.66666667,2.66666667 Z M18.6666667,9.33333333 L18.6666667,14.3333333 C18.6666667,14.7916667 18.5034722,15.1840278 18.1770833,15.5104167 C17.8506944,15.8368056 17.4583333,16 17,16 L1.66666667,16 C1.20833333,16 0.815972222,15.8368056 0.489583333,15.5104167 C0.163194444,15.1840278 0,14.7916667 0,14.3333333 L0,9.33333333 L7,9.33333333 L7,11 C7,11.1805556 7.06597222,11.3368056 7.19791667,11.46875 C7.32986111,11.6006944 7.48611111,11.6666667 7.66666667,11.6666667 L11,11.6666667 C11.1805556,11.6666667 11.3368056,11.6006944 11.46875,11.46875 C11.6006944,11.3368056 11.6666667,11.1805556 11.6666667,11 L11.6666667,9.33333333 L18.6666667,9.33333333 Z M10.6666667,9.33333333 L10.6666667,10.6666667 L8,10.6666667 L8,9.33333333 L10.6666667,9.33333333 Z M18.6666667,4.33333333 L18.6666667,8.33333333 L0,8.33333333 L0,4.33333333 C0,3.875 0.163194444,3.48263889 0.489583333,3.15625 C0.815972222,2.82986111 1.20833333,2.66666667 1.66666667,2.66666667 L5.33333333,2.66666667 L5.33333333,1 C5.33333333,0.722222222 5.43055556,0.486111111 5.625,0.291666667 C5.81944444,0.0972222222 6.05555556,0 6.33333333,0 L12.3333333,0 C12.6111111,0 12.8472222,0.0972222222 13.0416667,0.291666667 C13.2361111,0.486111111 13.3333333,0.722222222 13.3333333,1 L13.3333333,2.66666667 L17,2.66666667 C17.4583333,2.66666667 17.8506944,2.82986111 18.1770833,3.15625 C18.5034722,3.48263889 18.6666667,3.875 18.6666667,4.33333333 Z" ></path>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Unemployment
        </span>
      </div>
    `;
  }

  if (needs.includes('education')) {
    html += `
      <div class="mr-3 bg-white border border-solid border-dark-pale-blue py-4 px-5 w-64 rounded inline-block rounded-2xl mb-2">
        <span class="inline-block align-middle">
          <svg width="24" height="24" viewBox="0 0 24 17" fill="black" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.4791667,7.375 L18.6666667,10.6666667 C18.6944444,11.1458333 18.4097222,11.5902778 17.8125,12 C17.2152778,12.4097222 16.3993056,12.734375 15.3645833,12.9739583 C14.3298611,13.2135417 13.2083333,13.3333333 12,13.3333333 C10.7916667,13.3333333 9.67013889,13.2135417 8.63541667,12.9739583 C7.60069444,12.734375 6.78472222,12.4097222 6.1875,12 C5.59027778,11.5902778 5.30555556,11.1458333 5.33333333,10.6666667 L5.52083333,7.375 L11.5,9.26041667 C11.6527778,9.30902778 11.8194444,9.33333333 12,9.33333333 C12.1805556,9.33333333 12.3472222,9.30902778 12.5,9.26041667 L18.4791667,7.375 Z M24,4 C24,4.15972222 23.9236111,4.26736111 23.7708333,4.32291667 L12.1041667,7.98958333 C12.0763889,7.99652778 12.0416667,8 12,8 C11.9583333,8 11.9236111,7.99652778 11.8958333,7.98958333 L5.10416667,5.84375 C4.80555556,6.07986111 4.55902778,6.46701389 4.36458333,7.00520833 C4.17013889,7.54340278 4.05208333,8.16319444 4.01041667,8.86458333 C4.44791667,9.11458333 4.66666667,9.49305556 4.66666667,10 C4.66666667,10.4791667 4.46527778,10.8506944 4.0625,11.1145833 L4.66666667,15.625 C4.68055556,15.7222222 4.65277778,15.8090278 4.58333333,15.8854167 C4.52083333,15.9618056 4.4375,16 4.33333333,16 L2.33333333,16 C2.22916667,16 2.14583333,15.9618056 2.08333333,15.8854167 C2.01388889,15.8090278 1.98611111,15.7222222 2,15.625 L2.60416667,11.1145833 C2.20138889,10.8506944 2,10.4791667 2,10 C2,9.49305556 2.22569444,9.10763889 2.67708333,8.84375 C2.75347222,7.40625 3.09375,6.26041667 3.69791667,5.40625 L0.229166667,4.32291667 C0.0763888889,4.26736111 0,4.15972222 0,4 C0,3.84027778 0.0763888889,3.73263889 0.229166667,3.67708333 L11.8958333,0.0104166667 C11.9236111,0.00347222222 11.9583333,0 12,0 C12.0416667,0 12.0763889,0.00347222222 12.1041667,0.0104166667 L23.7708333,3.67708333 C23.9236111,3.73263889 24,3.84027778 24,4 Z" ></path>
          </svg>
        </span>
        <span class="ml-4 text-lg font-bold text-center inline-block align-middle">
          Education
        </span>
      </div>
    `;
  }


  html += `</div>`;
  return html;
};
